import { currencyLocaleMap } from "constants/currency-select"

export const formatPrice = (price: number, currency: string) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency
  }).format(price)
}

export const validatePrice = (price: string) => {
  const formatedPrice = price.toString().replace(",", ".")
  const priceToNumber = +formatedPrice
  const validPrice = !isNaN(priceToNumber) ? priceToNumber : 0

  return validPrice
}

export const formatAndValidatePrice = (price: string, currency: string) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency
  }).format(validatePrice(price))
}

export const formatCurrency = (value: string, currency: string): string => {
  if (!value) return ""

  const numericValue = value.replace(/\D/g, "")
  const amount = parseFloat(numericValue) / 100

  if (!currency) return amount.toString()

  // Default to 'pt-BR' if currency is not in the mapping
  const locale = currencyLocaleMap[currency] || "pt-BR"

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency
  }).format(amount)
}

export const processInitialFormatValue = (value: number | string): string => {
  if (typeof value === "string") {
    return Number(
      value
        .replaceAll(`.`, ``)
        .replace(/[^\d,]/g, "")
        .replaceAll(`,`, `.`)
    )
      .toFixed(2)
      .replaceAll(`.`, `,`)
  }

  return value.toFixed(2).replaceAll(`.`, `,`)
}

export const processFormatValue = (value: string): string => {
  let processedValue = value.replaceAll(`.`, `,`)

  processedValue = processedValue.replaceAll(`,`, ``)
  processedValue = processedValue.replace(/\D/g, "")
  processedValue = processedValue.replace(/^0+/, "")

  if (processedValue.length === 0) {
    return `0,00`
  } else if (processedValue.length === 1) {
    processedValue = `00${processedValue}`
  } else if (processedValue.length === 2) {
    processedValue = `0${processedValue}`
  }

  const processedValueDecimal = processedValue.slice(-2)
  const processedValueInteger = processedValue.slice(0, -2)

  return `${processedValueInteger},${processedValueDecimal}`
}
